import config from 'vue-xpc/src/config';

export default {
  name: 'variablesPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue) {
    Vue.prototype.SCSS_VARIABLES = config.get('scssVariables');
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/variables/index.js